import { Rule } from 'rc-field-form/lib/interface'
import _trim from 'lodash/trim'
import { ValidationI18n } from './Validate'

const INVISIBLE_CHARACTERS = /[\u200b-\u200f\u202a-\u202e\u2060-\u2069\ufeff]/g
const PHONE_CHARACTERS = /^\+?[\d\s()/.\-\u2013]+$/
const SEPARATORS = /[\s()/.\-\u2013]/g
const PHONE_DIGITS = /^(?:\+\d{7,16}|0\d{6,15})$/

export const cleanPhoneNumber = (value: string): string =>
  _trim(value.replace(INVISIBLE_CHARACTERS, ''))

export const isPhoneNumber = (value: string): boolean => {
  const phone = cleanPhoneNumber(value)
  return (
    PHONE_CHARACTERS.test(phone) &&
    PHONE_DIGITS.test(phone.replace(SEPARATORS, ''))
  )
}

export const phoneNumberRule = (
  i18n: ValidationI18n,
  storedValue?: string | null
): Rule => ({
  validator: async (_rule, value) => {
    if (typeof value !== 'string' || value === storedValue) {
      return
    }
    if (_trim(value).length > 0 && !isPhoneNumber(value)) {
      throw new Error(
        i18n._({ key: 'frontend:validation.phoneNumber.invalid' })
      )
    }
  },
})
